import { Options } from '../../Options'
import { ChartLegendConstants } from './ChartLegend.constants'

export const chartLegendOptions = Options.asRecord(
  Options.createOption({
    key: 'visible',
    inputKind: 'boolean',
    defaultValue: ChartLegendConstants.defaultShowLegend,
    label: 'Visible',
    description: 'Show the series legend outside the plot.',
    category: 'Legend',
  }),
  Options.createOption({
    key: 'orientation',
    inputKind: 'select',
    selectChoices: [
      { value: 'horizontal', label: 'Horizontal' },
      { value: 'vertical', label: 'Vertical' },
    ],
    defaultValue: ChartLegendConstants.defaultOrientation,
    label: 'Orientation',
    description: 'Lay out legend items in a row or a column.',
    category: 'Legend',
  }),
  Options.createOption({
    key: 'position',
    inputKind: 'select',
    selectChoices: [
      { value: 'top', label: 'Top' },
      { value: 'bottom', label: 'Bottom' },
    ],
    defaultValue: 'top',
    label: 'Position',
    description: 'Place the legend above or below the plot.',
    category: 'Legend',
  }),
  Options.createNested({
    key: '_legend',
    label: 'Legend',
    description: 'Series legend layout.',
    category: 'Legend',
  }),
)

export type ChartLegendOptions = Options.TypeOf<typeof chartLegendOptions>
export type ChartLegendOrientation = Options.ResolvedTypeOf<
  typeof chartLegendOptions
>['orientation']
export type ChartLegendPosition = Options.ResolvedTypeOf<
  typeof chartLegendOptions
>['position']
